<template>
    <!-- eslint-disable max-len -->
    <v-col>
        <v-row class="no-gutters align-center">
            <v-col class="pr-2 pr-md-0">
                <v-card
                    class="transaction"
                    flat
                    dense
                >
                    <v-row no-gutters>
                        <div class="flex-shrink-1">
                            <v-card
                                :class="request.status"
                                min-width="10"
                                height="100%"
                                flat
                                tile
                            />
                        </div>
                        <v-col class="">
                            <v-row
                                no-gutters
                                class="align-stretch"
                                :class="request.status"
                            >
                                <v-col
                                    class="flex-grow-0 pa-4 d-flex flex-column request-status"
                                >
                                    <div class="flex-grow-1 mb-4">
                                        <v-row
                                            no-gutters
                                            class="align-baseline justify-center"
                                        >
                                            <v-chip :class="request.status">
                                                <v-col class="text-right status pa-0">
                                                    {{ request.status.charAt(0).toUpperCase() + request.status.slice(1) }}
                                                </v-col>
                                            </v-chip>
                                        </v-row>
                                    </div>
                                    <v-spacer />
                                    <div class="transfer-dates text-center">
                                        <template v-if="request.created_at">
                                            <div class="blue-grey--text text--darken-2">
                                                <p class="overline blue-grey--text lighten-4 mb-0">
                                                    Created
                                                </p>
                                                <p class="body-2 font-weight-medium mb-0">
                                                    {{ request.created_at | moment('l') }} {{ request.created_at | moment('LT') }}
                                                </p>
                                            </div>
                                        </template>
                                    </div>
                                </v-col>

                                <v-divider
                                    :vertical="$vuetify.breakpoint.lgAndUp"
                                    light
                                    class="flex-shrink-1"
                                    width="1px"
                                    color="#f5f5f5"
                                />

                                <v-col
                                    class="d-flex align-center justify-center mx-n1 pa-5 col-12"
                                    lg="7"
                                    md="4"
                                >
                                    <v-row class="align-center justify-center flex-row no-wrap px-8 py-4 no-gutters">
                                        <v-col>
                                            <v-row class="align-end">
                                                <v-col class="flex-shrink-1 text-left d-flex flex-column align-center justify-left">
                                                    <div class="text-center text-lg-left">
                                                        <p class="overline blue-grey--text lighten-4 mb-0" style="line-height: 20px;">
                                                            <span v-if="userCanAcceptOffers">
                                                                You Will Send
                                                            </span>
                                                            <span v-else-if="request.benefactor_user">
                                                                {{ request.benefactor_user.firstname }} <br v-if="request.benefactor_user.firstname.length > 6" /> Will Send
                                                            </span>
                                                            <span v-else>
                                                                Your Benefactor <br /> Will Send
                                                            </span>
                                                        </p>
                                                        <p class="headline subtitle-1 font-weight-medium mb-0">
                                                            {{ request.amount | currency }}
                                                            <span class="pl-1 subtitle-2 font-weight-regular teal--text lighten-1">
                                                                {{ request.benefactor_currency }}
                                                            </span>
                                                        </p>
                                                    </div>
                                                </v-col>
                                                <v-col class="align-center justify-center flex-grow-1 col-12" lg="4">
                                                    <v-row class="d-flex flex-row flex-nowrap">
                                                        <v-col class="d-flex flex-grow-0 flex-shrink-1 align-center justify-center pa-0">
                                                            <v-tooltip top>
                                                                <template v-slot:activator="{ on }">
                                                                    <v-avatar
                                                                        class="primary--outline"
                                                                        size="38"
                                                                        v-on="on"
                                                                    >
                                                                        <!-- SENDING BANK ICON CHANGING NEEDS FUNCTIONALITY -->
                                                                        <v-icon
                                                                            color="primary"
                                                                            size="18"
                                                                        >
                                                                            mdi-bank-outline
                                                                        </v-icon>
                                                                    </v-avatar>
                                                                </template>
                                                                <span>Payment bank account</span>
                                                            </v-tooltip>
                                                        </v-col>

                                                        <v-col class="d-flex flex-grow-1 align-center justify-center pa-0">
                                                            <v-icon
                                                                color="blue-grey lighten-4"
                                                                size="10"
                                                            >
                                                                mdi-chevron-double-right
                                                            </v-icon>
                                                            <v-sheet
                                                                color="blue-grey lighten-4"
                                                                width="100%"
                                                                height="2px"
                                                            />
                                                        </v-col>

                                                        <v-col class="d-flex flex-grow-0 flex-shrink-1 align-center justify-center pa-0">
                                                            <!-- TODO: DURATION NEEDS FUNCTIONALITY -->
                                                            <v-chip outlined>
                                                                {{ p2pduration }}
                                                            </v-chip>
                                                        </v-col>

                                                        <v-col class="d-flex flex-grow-1 align-center justify-center pa-0">
                                                            <v-sheet
                                                                color="blue-grey lighten-4"
                                                                width="100%"
                                                                height="2px"
                                                            />
                                                            <v-icon
                                                                color="blue-grey lighten-4"
                                                                size="10"
                                                            >
                                                                mdi-chevron-double-right
                                                            </v-icon>
                                                        </v-col>

                                                        <v-col class="d-flex flex-grow-0 flex-shrink-1 align-center justify-center pa-0">
                                                            <v-tooltip top>
                                                                <template v-slot:activator="{ on }">
                                                                    <v-avatar
                                                                        class="primary--outline"
                                                                        size="38"
                                                                        v-on="on"
                                                                    >
                                                                        <!-- RECIPIENT BANK ICON CHANGING NEEDS FUNCTIONALITY -->
                                                                        <v-icon
                                                                            color="primary"
                                                                            size="18"
                                                                        >
                                                                            mdi-bank-outline
                                                                        </v-icon>
                                                                    </v-avatar>
                                                                </template>
                                                                <span>Recipient bank account</span>
                                                            </v-tooltip>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                                <v-col class="flex-shrink-1 text-right d-flex flex-column align-center justify-right">
                                                    <div class="text-center text-lg-right">
                                                        <p class="overline blue-grey--text lighten-4 mb-0" style="line-height: 20px;">
                                                            <span v-if="userCanAcceptOffers">
                                                                {{ request.user.firstname }} <br v-if="request.user.firstname.length > 6" /> Will Receive
                                                            </span>
                                                            <span v-else>
                                                                You Will Receive
                                                            </span>
                                                        </p>
                                                        <p class="headline subtitle-1 font-weight-medium mb-0">
                                                            {{ getRequestorAmount(request) | currency }}
                                                            <span class="pl-1 subtitle-2 font-weight-regular teal--text lighten-1">
                                                                {{ request.requestor_currency }}
                                                            </span>
                                                        </p>
                                                    </div>
                                                </v-col>
                                            </v-row>
                                            <v-row class="align-end">
                                                <v-col class="flex-shrink-1 text-center d-flex flex-column align-center justify-center pa-0 pa-lg-3 col-12" lg="6">
                                                    <div>
                                                        <p class="overline blue-grey--text lighten-4 mb-0">
                                                            Exchange rate ({{ request.requestor_currency }}/{{ request.benefactor_currency }})
                                                        </p>
                                                        <p class="body-1 font-weight-medium mb-0">
                                                            {{ strongerExchangeRate(request) | currency }}
                                                        </p>
                                                    </div>
                                                </v-col>
                                                <template v-if="request.fee">
                                                    <v-col class="flex-shrink-1 text-center d-flex flex-column align-center justify-center pa-0 pa-lg-3">
                                                        <div>
                                                            <p class="overline blue-grey--text lighten-4 mb-0">
                                                                fee
                                                            </p>
                                                            <p class="body-1 font-weight-medium mb-0">
                                                                <span>
                                                                    0.01 - 0.98
                                                                </span>
                                                                <span class="pl-1 caption font-weight-regular teal--text lighten-1">
                                                                    {{ request.benefactor_currency }}
                                                                </span>
                                                            </p>
                                                        </div>
                                                    </v-col>
                                                </template>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col class="d-flex justify-center align-center flex-column pa-2">
                                    <v-btn
                                        v-if="request.status === 'pending' && $store.state.user.can_post_offers"
                                        color="red"
                                        dark
                                        depressed
                                        large
                                        text
                                        width="170px"
                                        @click="cancelButtonClicked(request)"
                                    >
                                        Cancel
                                    </v-btn>

                                    <template v-if="userCanAcceptOffers">
                                        <v-btn
                                            v-if="request.status === 'pending'"
                                            color="primary"
                                            dark
                                            depressed
                                            large
                                            width="170px"
                                            @click="acceptButtonClicked(request)"
                                        >
                                            Accept
                                        </v-btn>

                                        <v-btn
                                            v-if="request.status === 'pending'"
                                            text
                                            color="red darken-2"
                                            large
                                            width="170px"
                                            class="px-2 mt-4"
                                            @click.prevent="declineButtonClicked(request)"
                                        >
                                            Decline
                                        </v-btn>
                                    </template>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
    </v-col>
</template>

<script>
/* eslint-disable no-else-return */
/* eslint-disable no-lonely-if */
/* eslint-disable max-len */
    export default {
        props: getProps(),
        data,
        computed: getComputed(),
        methods: getMethods(),
    };

    function getProps() {
        return {
            initialRequest: {},
            initialRequestor: {},
        };
    }

    function data() {
        return {
            request: this.initialRequest,
            requestor: this.initialRequestor,
        };
    }


    function getMethods() {
        return {
            strongerExchangeRate,
            declineButtonClicked,
            acceptButtonClicked,
            getRequestorAmount,
            getRequestor,
            cancelButtonClicked,
        };

        function getRequestorAmount(request) {
            if (request.type === '3po') {
                return Number((request.amount - request.fee) * request.exchange_rate).toFixed(2);
            } else {
                return Number(request.amount * request.exchange_rate).toFixed(2);
            }
        }

        function strongerExchangeRate(match) {
            if (match.exchange_rate < 1) {
                if (match.exchange_rate === 0) {
                    return 0;
                } else {
                    return 1 / match.exchange_rate;
                }
            } else {
                return match.exchange_rate;
            }
        }

        function declineButtonClicked(request) {
            const vm = this;
            vm.$swal({
                type: 'warning',
                title: 'Warning',
                html: '<p><strong>Do you really want to decline this payment request?</strong></p>',
                showCancelButton: true,
                preConfirm: () => {
                    vm.loading = true;
                    Vue.backendApi().paymentRequest().decline(request.id, vm.$store.state.user.id).then(success, error);
                },
            });

            function success(response) {
                vm.loading = false;
                request.status = response.data.status;
                vm.$swal({
                    type: 'success',
                    title: 'Payment request successfully declined',
                    text: 'Click OK to continue',
                });
            }

            function error(err) {
                vm.$swal({
                    type: 'error',
                    title: 'Error deleting Payment Request',
                    text: err,
                });
            }
        }

        async function getRequestor(id) {
            const response = await Vue.backendApi().user(id).getUser();

            if (response.data) {
                return response.data;
            } else {
                return {};
            }
        }

        async function acceptButtonClicked(request) {
            try {
                this.loading = true;
                const response = await Vue.backendApi().user(this.$store.state.user.id)
                    .getPaymentMethods();

                if (response.data.items && response.data.items.length > 0) {
                    this.loading = true;
                    const requestor = await getRequestor(request.user_id);
                    this.$emit('update:selectedOrder', request);
                    this.$emit('update:requestor', requestor);
                    this.$emit('open-make-payment');
                } else {
                    this.loading = false;
                    this.$swal({
                        type: 'error',
                        title: 'Payment method needed',
                        text: 'You need to register your payment method under profile settings before you can make a transfer or accept payment requests',
                    }).then((result) => {
                        if (result.value) {
                            this.showTutorialVideo('payment');
                        }
                    });
                }
            } catch (err) {
                this.loading = false;
                this.$swal({
                    type: 'error',
                    title: 'Error loading payment methods',
                    text: err
                });
            }
        }

        async function cancelButtonClicked(request) {
            const vm = this;
            try {
                const { value: isConfirm } = await vm.$swal({
                    type: 'warning',
                    title: 'Warning',
                    html: '<p><strong>Do you really want to cancel this Payment Request?</strong></p>',
                    showCancelButton: true,
                });

                if (isConfirm) {
                    vm.loading = true;
                    await window.Vue.backendApi()
                        .paymentRequest()
                        .deletePaymentRequest(request.id);

                    // Set cancelled status
                    this.request.status = 'cancelled';

                    vm.$swal({
                        type: 'success',
                        title: 'Payment Request cancelled',
                        text: 'Click OK to continue',
                    });
                }
            } catch (error) {
                vm.$swal({
                    type: 'error',
                    title: 'Error deleting Payment Request',
                    text: error,
                });
            } finally {
                vm.loading = false;
            }
        }
    }

    function getComputed() {
        return {
            status,
            userCanAcceptOffers,
            p2pduration,
        };

        function status() {
            return this.request.status;
        }

        function userCanAcceptOffers() {
            return this.$store.state.user.can_accept_offers;
        }

        function p2pduration() {
            const currencies = [
                'KES',
                'GHS',
                'ZAR',
            ];

            if (this.order && currencies.find(this.order.poster_currency)) {
                return '2-3 days';
            } else {
                return '0-1 days';
            }
        }
    }
</script>

<style scoped>
a {
    color: inherit; /* blue colors for links too */
    text-decoration: inherit; /* no underline */
}

.request-status {
    min-width: 375px;
}

@media screen and (min-width: 767px) {
    .request-status {
        min-width: 250px;
    }
}

.statusBar {
    position: absolute;
    top: 0;
    width: 100%;
    color: #cfd8dc;
}

/* Processing & Unpaid */
.v-card.processing, .v-card.unpaid, .v-card.pending{
    background-color: #dde !important;
    border-color: #dde !important;
    color: #000000aa !important;
}

.v-chip.processing, .v-chip.unpaid, .v-chip.pending {
    background: #dde !important;
    color: #000000aa !important;
}

/* Payment Received */
.v-card.received, .v-card.accepted {
    background-color: #FDD835 !important;
    border-color: #FDD835 !important;
    color: #000000aa !important;
}

.v-chip.received, .v-chip.accepted {
    background: #FDD835 !important;
    color: #000000aa !important;
}

/* Completed */
.v-card.completed {
    background-color: #0cd6c0 !important;
    border-color: #0cd6c0 !important;
    color: #000000aa !important;
}

.v-chip.completed {
    background: #0cd6c0 !important;
    color: #000000aa !important;
}

/* Cancelled */
.v-card.cancelled, .v-card.declined {
    background-color: #FF8A80 !important;
    border-color: #FF8A80 !important;
    color: #bbb !important;
}

.v-chip.cancelled, .v-chip.declined {
    background: #FF8A80 !important;
    color: #000000aa !important;
}

.cancelled i.v-icon.notranslate.mdi.mdi-bank-outline.theme--light.primary--text,  .cancelled p, .cancelled span {
    color: #bbb !important;
    caret-color: #bbb !important;
}

.cancelled .primary--outline {
    border: 2px solid #bbb;
}

.theme--light.v-divider {
    border-color: rgba(0,0,0,0.02);
}

.transaction {
    overflow: hidden;
}

.primary--outline {
    background-color: transparent;
    border: 2px solid #3F51B5;
}

.transfer-dates > div {
    margin-bottom: 16px;
}

.transfer-dates :last-child {
    margin-bottom: unset;
}
</style>
<style lang="scss" scoped>
.paid-button {
    animation: shadow-pulse 1s infinite;
}

.flashing-text {
    font-size: 13px;
    color: red;
}

@keyframes shadow-pulse
{
    0% { transform: scale(1); }
    30% { transform: scale(1); }
    40% { transform: scale(1.08); }
    50% { transform: scale(1); }
    60% { transform: scale(1); }
    70% { transform: scale(1.05); }
    80% { transform: scale(1); }
    100% { transform: scale(1); }
}
</style>
